<template>
  <section class="search-sidebar__content">
    <fieldset class="fieldset">
      <legend class="fieldset__label">{{ title }}</legend>

      <button
        v-if="sessionStatus !== 'checklists' || checklists.length"
        class="button _left-icon"
        @click="onReturnButtonClick"
      >
        <svg width="16" height="16">
          <use xlink:href="#arrow-sides"></use>
        </svg>
        Вернуться к поисковому фильтру
      </button>

      <div class="search-filter__selected-items">
        <span
          v-for="(item, index) in selectedChecklists"
          :key="item.id"
          class="search-filter__selected-item"
        >
          {{ item.title | truncateText(100, 40) }}
          <span
            class="search-filter__selected-item-delete"
            @click="deleteItem(index)"
          >
            &times;
          </span>
        </span>
      </div>
    </fieldset>

    <form
      class="checklists__search"
      @submit.prevent="loadChecklists(searchTitle)"
    >
      <div class="checklists__search-field">
        <input
          v-model="searchTitle"
          class="checklists__search-input"
          type="text"
          placeholder="Введите название перечня"
        />

        <span
          v-show="searchTitle"
          class="checklists__search-clean"
          @click="onSearchClean"
        >
          <svg class="icon--cross" width="24" height="24">
            <use xlink:href="#cross" />
          </svg>
        </span>
      </div>

      <button class="button" type="submit">
        Поиск
      </button>
    </form>

    <loader-dots v-if="loading">
      <template v-slot:text>
        Загрузка списка перечней...
      </template>
    </loader-dots>

    <div v-else-if="loadingError" class="message _error">
      Ошибка: «{{ loadingError.message }}»
    </div>

    <!-- TODO: BUG >> undefined checklists -->
    <div
      v-else-if="!checklists || !checklists.length"
      class="message _attention"
    >
      Перечни не найдены.
    </div>

    <div v-show="!loading && !loadingError" class="checklists__list">
      <template v-for="group in checklists">
        <search-checklists-item
          v-for="item in group.items"
          :key="item.id"
          :data="item"
        />
      </template>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import SearchChecklistsItem from './SearchChecklistsItem';
import LoaderDots from '@@/shared/loaders/LoaderDots';

export default {
  components: {
    SearchChecklistsItem,
    LoaderDots
  },

  data: () => ({
    searchTitle: '',
    loading: false,
    loadingError: null
  }),

  computed: {
    ...mapGetters({
      checklistsSearchString: 'checklistsSearchString',
      selectedChecklists: 'selectedChecklists',
      checklists: 'foundedChecklists',
      sessionStatus: 'searchSessionStatus'
    }),

    title() {
      return this.sessionStatus === 'checklists'
        ? 'Выбранные перечни'
        : 'Выбранные перечни [режим фильтра]';
    }
  },

  // Watcher (к сожалению) нужен для отслеживания сброса запроса через компонент QuerySummary
  watch: {
    checklistsSearchString: function(newVal) {
      this.searchTitle = newVal;
    }
  },

  created: function() {
    this.searchTitle = this.checklistsSearchString
      ? this.checklistsSearchString
      : undefined;
    this.loadChecklists(this.searchTitle);
  },

  methods: {
    // Загрузка списка перечней: параметр searchStr может отсутствовать для хука created
    // при создании компонента или присутствовать при изменении значения поиска в инпуте
    async loadChecklists(searchStr) {
      this.loading = true;
      if (searchStr === undefined) {
        await this.$store.dispatch('getChecklisits');
      } else {
        await this.$store.dispatch('getChecklisits', searchStr);
      }
      this.loading = false;
    },
    onSearchClean() {
      this.searchTitle = '';
    },
    onReturnButtonClick() {
      this.$emit('return');
    },
    deleteItem(ind) {
      this.$store.dispatch('changeChecklistsQuery', {
        mode: 'remove',
        value: this.selectedChecklists[ind]
      });
    }
  }
};
</script>
